import { Container } from './styles'
import { ReactComponent as CuradoriaIcon } from '../../../assets/curadoriaIcon.svg'
import { ReactComponent as IneditosIcon } from '../../../assets/ineditosIcon.svg'
import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@taglivros/tag-components'
export function Category( { categoryId, isSelected, handleCategoryClick } ) {
  const handleClick = () => {
    handleCategoryClick( categoryId )
  }

  const categoryList = {
    // Curadoria
    '1': {
      'color': 'azulEscuro',
      'icon': (
        <CuradoriaIcon
          aria-label="Imagem Curadoria"
          height="110"
          role="img"
          width="110"
        />
      ),
      'text': 'Grandes nomes da literatura indicam seus livros preferidos aos associados.'
    },
    // Inéditos
    '2': {
      'color': 'laranja',
      'icon': (
        <IneditosIcon
          aria-label="Imagem Inéditos"
          height="110"
          role="img"
          width="100"
        />
      ),
      'text': 'Best-sellers mundiais e grandes apostas da literatura ainda inéditos no Brasil.',
    },
  }

  return (
    <Container
      color={ categoryList[ categoryId ].color }
      data-testid={ `category-${categoryId}` }
      isSelected={ isSelected }
      onClick={ handleClick }
    >

      {categoryList[ categoryId ].icon}
      <Typography
        as="span"
        color="cinza500"
        fontWeight="l"
        variant="helperText"
      >
        {categoryList[ categoryId ].text}
      </Typography>
    </Container>
  )
}

Category.propTypes = {
  'categoryId': PropTypes.number.isRequired,
  'handleCategoryClick': PropTypes.func.isRequired,
  'isSelected': PropTypes.bool.isRequired,
}
